(() => {
  function initJobInterestLinks(root = document) {
    const links = root.querySelectorAll ? root.querySelectorAll('[data-job-interest-link]') : [];
    links.forEach((link) => {
      if (link.dataset.jobUrlReady === 'true') return;
      const jobTitle = link.dataset.jobTitle;
      if (!jobTitle || !link.href) return;
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('job', jobTitle);
        link.href = url.toString();
        link.dataset.jobUrlReady = 'true';
      } catch (error) {
        console.warn('DocHop: could not prepare job interest link.', error);
      }
    });
  }

  function setControlValue(control, value) {
    if (!control) return false;

    try {
      if (control.tagName === 'SELECT') {
        const option = Array.from(control.options || []).find(
          (item) => item.value === value || item.textContent.trim() === value
        );
        if (!option) return false;
        control.value = option.value;
      } else {
        const prototype = control instanceof HTMLTextAreaElement
          ? HTMLTextAreaElement.prototype
          : HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
        if (descriptor && descriptor.set) {
          descriptor.set.call(control, value);
        } else {
          control.value = value;
        }
      }

      control.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      control.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      control.dispatchEvent(new Event('blur', { bubbles: true, composed: true }));
      return String(control.value || '') === String(value);
    } catch (error) {
      try {
        control.value = value;
        control.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        control.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        return String(control.value || '') === String(value);
      } catch (ignore) {
        return false;
      }
    }
  }

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function fieldContext(control) {
    const parts = [
      control.getAttribute('aria-label'),
      control.getAttribute('placeholder'),
      control.getAttribute('name'),
      control.getAttribute('id'),
      control.getAttribute('data-label')
    ];

    const parent = control.parentElement;
    if (parent) {
      parts.push(parent.innerText || '');
      const label = parent.querySelector ? parent.querySelector('label') : null;
      if (label) parts.push(label.innerText || '');
    }

    return normalise(parts.filter(Boolean).join(' | '));
  }

  function findJobFieldInRoot(root) {
    if (!root || !root.querySelectorAll) return null;

    const target = 'job vacancy interested in';
    const controls = Array.from(root.querySelectorAll('input, textarea, select'));

    for (const control of controls) {
      const context = fieldContext(control);
      if (context.includes(target) || context.includes('job vacancy')) {
        return control;
      }
    }

    const labels = Array.from(root.querySelectorAll('label'));
    for (const label of labels) {
      const text = normalise(label.textContent);
      if (!text.includes(target)) continue;

      const forId = label.getAttribute('for');
      if (forId && root.getElementById) {
        const byId = root.getElementById(forId);
        if (byId) return byId;
      }

      const wrapper = label.closest('div, fieldset, section, li') || label.parentElement;
      const control = wrapper && wrapper.querySelector
        ? wrapper.querySelector('input, textarea, select')
        : null;
      if (control) return control;
    }

    return null;
  }

  function walkOpenShadowRoots(root, finder, seen = new Set()) {
    if (!root || seen.has(root)) return null;
    seen.add(root);

    const direct = finder(root);
    if (direct) return direct;

    if (!root.querySelectorAll) return null;

    for (const node of root.querySelectorAll('*')) {
      if (node.shadowRoot) {
        const found = walkOpenShadowRoots(node.shadowRoot, finder, seen);
        if (found) return found;
      }
    }

    return null;
  }

  function findShopifyFormsJobField() {
    const selector = '[data-testid="field-custom#job_vacancy_interested_in"]';
    const hosts = document.querySelectorAll('shopify-forms-embed');

    for (const host of hosts) {
      if (!host.shadowRoot) continue;
      const field = host.shadowRoot.querySelector(selector) ||
        host.shadowRoot.querySelector('#custom\\#job_vacancy_interested_in');
      if (field) return field;
    }

    return null;
  }

  function prefillJobInterestForm() {
    const params = new URLSearchParams(window.location.search);
    const jobTitle = params.get('job');
    if (!jobTitle) return false;

    const field = findShopifyFormsJobField();
    if (!field) return false;

    if (normalise(field.value) === normalise(jobTitle)) return true;

    return setControlValue(field, jobTitle);
  }

  function init() {
    initJobInterestLinks();
    prefillJobInterestForm();

    const observer = new MutationObserver(() => {
      initJobInterestLinks();
      prefillJobInterestForm();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', () => {
      initJobInterestLinks();
      prefillJobInterestForm();
    });

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;

      if (prefillJobInterestForm() || attempts >= 120) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
